import { Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { BbitWebsiteService, I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { BookingInfoOverlayRef } from './booking-info-overlay.ref';

export enum PlaceBookingStepInput {
  FILE = 'file',
  OPTIONAL_MULTI_FILE = 'optional-multi-file',
  TERMS = 'terms',
  SUBMIT = 'submit',
}

@Component({
  selector: 'app-booking-info-overlay',
  templateUrl: './booking-info-overlay.component.html',
  styleUrl: './booking-info-overlay.component.scss',
  imports: [NgIcon, FormsModule, I18nPipe],
})
export class BookingInfoOverlayComponent {
  public displayMode = signal<'loggedOut'>('loggedOut');

  constructor(
    private _overlayRef: BookingInfoOverlayRef,
    private _website: BbitWebsiteService,
  ) {
    this._website
      .observeProfile()
      .pipe(takeUntilDestroyed())
      .subscribe(async (profile) => {
        if (!profile) {
          this.displayMode.set('loggedOut');
          return;
        }
      });
  }

  login(): void {
    this._website.login();
  }

  close(): void {
    this._overlayRef.close();
  }
}
